import React, {useState} from 'react';
import Modal from '../Modal';

const WarningDialog = (props) => {
 return <Modal open={props.open} setOpen={props.setOpen} text={props.dialogText} title={props.dialogTitle}/>
}

export default WarningDialog;
